import cx from 'classnames';
import FadeIn from '@/components/FadeIn';

type OverlayButtonProps = React.PropsWithChildren<{
  className?: string;
  icon?: React.ReactElement;
  iconPosition?: 'left' | 'right';
  onClick: () => void;
  text: string;
}>;

export const OverlayButton: React.FC<OverlayButtonProps> = ({
  className,
  icon,
  iconPosition = 'left',
  onClick,
  text,
}) => {
  return (
    <FadeIn delay={100} direction="left" className={className}>
      <>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}
          className={cx(
            'rounded-md bg-gray-800 px-4 py-2 font-semibold text-gray-100 transition-all hover:bg-gray-700 hover:text-white flex gap-2 items-center text-sm',
            {
              'flex-row-reverse': iconPosition === 'right',
            }
          )}
        >
          {icon}
          <span>{text}</span>
        </button>
      </>
    </FadeIn>
  );
};
